import React from "react";

const Loader = ({ color }) => {
  return (
    <div>
      <i
        className="fa fa-spinner fa-pulse fa-3x fa-fw mb-4"
        style={{ color: color, fontSize: "20px" }}
      ></i>
    </div>
  );
};

export default Loader;
